/**
 * La date d'une session, en toutes lettres et en francais, ECRITE UNE FOIS ET LUE DES DEUX COTES.
 *
 * ⚠️ ELLE NE VIT PLUS DANS `app/inscription/page.tsx` DEPUIS LE 2026-08-19, ET LE MOTIF EST UN
 * DEFAUT MESURE : la page mettait la date en forme, les emails ne la mettaient pas. Une personne
 * lisait donc « samedi 5 septembre 2026 » sur l'ecran, puis « 2026-09-05 » dans l'email de
 * confirmation qui arrivait derriere, sur la meme session. Les deux valeurs venaient de la meme
 * colonne, et une seule des deux traversait une mise en forme.
 *
 * LA PREMIERE LETTRE EST UNE MAJUSCULE, ET C'EST UNE DEMANDE DE WAHID DU 2026-08-19 : « il manque
 * une majuscule a samedi 5 septembre 2026 qui devrait se lire Samedi ». `Intl` rend le jour de la
 * semaine en minuscule en francais, la majuscule se pose donc apres coup. `contenu-site.md` v16
 * § Etape 1 l'ecrit dans le tableau des intitules.
 *
 * LE FUSEAU EST FIXE A UTC, ET CE N'EST PAS UNE PRECAUTION DECORATIVE : `2026-09-05` se lit comme
 * minuit UTC, et un serveur place derriere UTC rendrait la veille, soit le 4 septembre. La
 * production tourne en UTC, la machine de developpement en heure du Maroc : sans ce fuseau, les deux
 * ne rendraient pas la meme date le jour ou l'une des deux passerait derriere.
 */
const FORMAT: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
};

/**
 * Rend `2026-09-05` sous la forme `Samedi 5 septembre 2026`.
 *
 * ELLE REND LA CHAINE RECUE QUAND ELLE N'EST PAS UNE DATE, plutot que « Invalid Date » : une session
 * sans jour existe dans la base, la colonne etant nullable, et un email vaut mieux qu'un email
 * portant un message d'erreur de moteur.
 */
export function enDateLisible(jour: string): string {
  if (!jour) return '';
  const date = new Date(jour);
  if (Number.isNaN(date.getTime())) return jour;
  const lisible = date.toLocaleDateString('fr-FR', FORMAT);
  return lisible.charAt(0).toUpperCase() + lisible.slice(1);
}

/**
 * L'horaire d'une session, `de 09:00 a 17:00`, a partir des deux colonnes d'heure.
 *
 * LE GABARIT NE S'ECRIT PAS ICI : il vit sous `contenu.redactionDev.session.gabaritHoraire`, ou
 * `AC-DSN-023` le compte comme l'une des chaines redigees par le dev. Cette fonction ne fait que
 * poser les deux valeurs dedans, et elle est le seul endroit qui le fasse depuis le 2026-08-19 :
 * l'ecran de l'etape 1, le recapitulatif de l'etape 3 et l'email de confirmation l'appellent tous
 * les trois.
 */
export function enHoraireLisible(gabarit: string, debut: string, fin: string): string {
  return gabarit.replace('{debut}', debut).replace('{fin}', fin);
}
